import { injectable } from 'tsyringe'
import { UserReportApiRepository } from '@/app/repositories/api/UserReportApiRepository'
import { UserReport } from '@/domain/entities/UserReport'

@injectable()
export class UserReportPresenter {
  private repository: UserReportApiRepository

  constructor(repository: UserReportApiRepository) {
    this.repository = repository
  }

  public loadUserReport(params: Object): Promise<UserReport> {
    return this.repository.getAll(params)
  }
}
